<ng-select
    [loadingText]="'defaults.loading' | translation | async"
    [notFoundText]="'defaults.noItemsFound' | translation | async"
    [searchable]="false"
    [items]="RoleMenus$ | async"
    bindLabel="name"
    bindValue="value"
    (change)="emitSelect($event.value)"
    [placeholder]="'properties.selectARole' | translation | async"
    [(ngModel)]="selectedRole"
>
    <ng-template ng-option-tmp let-item="item">
        <div [ngbTooltip]="item.name" placement="auto" [openDelay]="0" class="text-truncate">{{ item.name }}</div>
    </ng-template>
</ng-select>
